import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import logo from '../public/logo.png';

interface LogoProps {
  portalText?: string;
  isLinked?: boolean;
}

const styles = {
  logoContainer: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 1,
  },
  portalText: {
    fontSize: '1.25rem',
    fontWeight: 500,
    lineHeight: '1rem',
    letterSpacing: '0.0075em',
    whiteSpace: 'nowrap',
  },
};

export default function Logo({ portalText, isLinked = false }: LogoProps) {
  let image = <img height="32px" alt="logo" src={logo} />;
  if (isLinked) {
    image = <a href="https://bento.net">{image}</a>;
  }

  return (
    <Box sx={portalText ? styles.logoContainer : undefined}>
      {image}
      {portalText && <Typography sx={styles.portalText}>{portalText}</Typography>}
    </Box>
  );
}
